module.exports = ":host .container-fluid {\n  max-width: 1280px;\n  padding-right: 0;\n  padding-left: 0; }\n  @media (max-width: 1315px) {\n    :host .container-fluid {\n      padding-right: 2.25rem;\n      padding-left: 2.25rem; } }\n  :host .background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-attachment: fixed;\n  width: 100vw;\n  height: 100vh;\n  max-width: 100%;\n  z-index: -1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/general-view/general-view.component.scss
// module id = ./src/app/views/general-view/general-view.component.scss
// module chunks = main